export const removeBase64Prefix = (base64String) => {
  return base64String.replace(/^data:image\/[a-z]+;base64,/, "")
}
